export const MESSAGES = {
    ERROR:
        'We encountered an unexpected problem. Please contact our Admin if you have any enquiries.'
};

export const RESOLVED_STATE = 8;
